<template>
  <div>
    <div class="box box-warning">
      <div class="box-header">
        <h3 class="box-title dashboard-title">
          {{ $t("dashboard.chart_monthly") }}
        </h3>
        <div class="box-tools pull-right">
          <div style="width:110px;">
            <div class="input-group date">
              <date-picker
                ref="periodPicker"
                v-model="datePickerValue"
                @dp-change="onHandleChangeMonth(datePickerValue)"
                :config="optionsPicker"
                :placeholder="$t('invoice.issuePeriod')"
              ></date-picker>
              <div class="input-group-addon" type="button" @click="$refs.periodPicker.dp.show()">
                <i class="fa fa-caret-down"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-body">
        <div class="chart">
          <LTEChart :chart-config="lineChartConfig"> </LTEChart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LTEChart from "@/components/LTEChart";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from '@/lib/utils'

export default {
  name: "ApartmentPerMonthLineChart",
  data() {
    return {
      datePickerValue: moment().format("YYYY/MM"),
      optionsPicker: {
        // useCurrent: false,
        minDate: new Date(2019, 0),
        maxDate: moment(),
        format: "YYYY/MM",
        locale: this.$i18n.locale == "en" ? "en" : "vi"
      },
      lineChartConfig: {
        type: "line",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          responsive: true,
          legend: {
            display: true,
            position: "top",
            labels: {
              usePointStyle: true
            }
          },
          tooltips: {
            mode: "index",
            intersect: false
          },
          hover: {
            mode: "nearest",
            intersect: true
          },
          scales: {
            xAxes: [
              {
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: "Ngày"
                },
                ticks: {
                  autoSkip: true,
                  maxTicksLimit: 10
                }
              }
            ],
            yAxes: [
              {
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: "Căn Hộ"
                },
                ticks: {
                  min: 0,
                  stepSize: 1
                }
              }
            ]
          }
        }
      }
    };
  },
  watch: {
    GET_LANG: function() {
      this.optionsPicker.locale = this.$i18n.locale == "en" ? "en" : "vi";
    }
  },
  computed: {
    ...mapGetters([
      "GET_LANG"
    ]),
    dateViewOptions: function() {
      return sessionStorage.getItem('projectDateViewOptions')
    }
  },
  methods: {
    ...mapActions([
      "GET_APARTMENT_REPORT"
    ]),
    onHandleChangeMonth: function(value) {
      this.renderChart();
    },
    renderChart: function() {
      const filter = {
        params: {
          ...utils.getAccountingPeriodFromDate(this.datePickerValue, "YYYY/MM")
        }
      };
      this.GET_APARTMENT_REPORT(filter).then(
        function(res) {
          let labels = [];
          let handover_dataset = [];
          let rental_dataset = [];
          let datasets = [
            {
              label: "Căn Hộ Đã Bàn Giao",
              fill: false,
              backgroundColor: "orange",
              borderColor: "orange",
              data: []
            },
            {
              label: "Căn Hộ Cho Thuê",
              fill: false,
              backgroundColor: "dodgerblue",
              borderColor: "dodgerblue",
              data: []
            }
          ];
          let data = res.data;
          data.forEach((ele, i) => {
            let dayview = utils.formatSqlDate(ele.day, null, "DD-MM");
            labels.push(dayview);
            handover_dataset.push(ele.statistic.handover);
            rental_dataset.push(ele.statistic.rental);
          });
          datasets[0].data = handover_dataset;
          datasets[1].data = rental_dataset;
          let clone_lineChartConfig = Object.assign({}, this.lineChartConfig);
          clone_lineChartConfig.data.labels = labels;
          clone_lineChartConfig.data.datasets = datasets;
          this.lineChartConfig = clone_lineChartConfig;
        }.bind(this)
      );
    }
  },
  components: {
    LTEChart,
    "date-picker": datePicker
  },
  mounted() {
    this.renderChart();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-box-content {
  margin-left: 0px;
  line-height: 35px;
}

.info-box-number {
  display: inline;
  font-size: 14px;
  padding: 12px;
}

.info-box-title {
  font-size: 25px;
  color: black !important;
  background: linear-gradient(
    to top,
    #9c9e9f 0%,
    #9c9e9f 50%,
    #adada7 50%,
    #ccc1c1 100%
  );
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ApartmentPerMonthLineChart.vue